import { Component, Input, OnInit, Optional, inject } from "@angular/core";
import { EditMode, RobotRulesService } from "../robot-rules.service";
import { NzModalRef } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import { TranslateService } from "@root/shared/service/translate.service";

@Component({
  selector: "host-gap-rules",
  templateUrl: "./gap-rules.component.html",
  styleUrls: ["./gap-rules.component.scss"],
})
export class GapRulesComponent implements OnInit {
  @Input() listOfChannelOption = [];
  @Input() editMode: EditMode = EditMode.Create;
  @Input() id;
  listOfAccountOption = [];
  //#region Params
  channel;
  account;
  properties = {
    /**
     * 后端接受的值为 all | by_property | by_group | by_room_type
     * 前端因为兼容问题，组件接受的值为 none | house | room_type | group
     * 所以在 save 和获取 detail 的时候，需要转换一下
     */
    type: "none",
    value: null,
  };
  event = "detected_an_unbookable_gap";
  defaultMinStay = 1;
  //#endregion
  modalRef = inject(NzModalRef, { optional: true });
  constructor(
    private robotSrv: RobotRulesService,
    private msg: NzMessageService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    if (this.editMode === EditMode.Update || this.editMode === EditMode.Copy) {
      this.fetchRuleDetail();
    }

    this.fetchChannelAccounts();
  }

  onSelectChannels(data) {
    this.fetchChannelAccounts();
  }

  onSave() {
    this.requestUpdateRule();
  }

  onCancel() {
    this.modalRef?.destroy();
  }

  private fetchRuleDetail() {
    const params = { id: this.id };
    this.robotSrv.fetchGapRuleDetail(params).subscribe((rst: any) => {
      const record = rst?.data?.record;
      if (record) {
        this.channel = record?.channel;
        this.account = record?.account;
        this.properties = {
          type: this.propertyTypeConverter(record?.property_type),
          value: record.property_ids,
        };
        this.defaultMinStay = record.default_min_stay;
      }
    });
  }

  private requestUpdateRule() {
    const params = {
      event: this.event,
      channel: this.channel,
      account: this.account,
      property_type: this.propertyTypeConverter(this.properties.type),
      property_ids: this.properties.value,
      default_min_stay: this.defaultMinStay,
    };

    if (this.editMode === EditMode.Update) {
      Object.assign(params, { id: this.id });
    }
    this.robotSrv.requestUpdateGapRule(params).subscribe((rst: any) => {
      if (rst.error_code === 0) {
        this.msg.success(this.t.t("word.success"));
        this.modalRef?.destroy();
      }
    });
  }

  private fetchChannelAccounts() {
    const params = {
      from: "gap",
    };
    if (this.channel) {
      Object.assign(params, { thirdparty_types: JSON.stringify(this.channel) });
    }
    this.robotSrv.fetchChannelAccounts(params).subscribe((rst) => {
      this.listOfAccountOption = rst?.data?.list?.map((account) => ({
        ...account,
        label: account.username,
        value: account.id,
      }));
    });
  }

  private propertyTypeConverter(type) {
    const map = {
      none: "all",
      house: "by_property",
      room_type: "by_room_type",
      group: "by_group",
      all: "none",
      by_property: "house",
      by_room_type: "room_type",
      by_group: "group",
    };
    return map[type];
  }
}
